import { useLoggedOutSuppliersPageCurrentNavigationPath } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/Context/useLoggedOutSuppliersPageCurrentNavigationPath";
import { brandsSearchRequest } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/__internal__/brandsSearchRequest";
import { useLoggedOutSuppliersPageFilterKeysQueryParams } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/QueryParams/useLoggedOutSuppliersPageFilterKeysQueryParams";
import { useLoggedOutSuppliersPageZeroIndexedPageNumberQueryParams } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/QueryParams/useLoggedOutSuppliersPagePageNumberQueryParams";
import { getQueryKey } from "@faire/web-api--source/endpoints/www/api/v2/search/brands/get-hooks";

export const useLoggedOutSuppliersPageBrandsSearchRequest = () => {
  const navigationPath = useLoggedOutSuppliersPageCurrentNavigationPath();
  const { filterKeys } = useLoggedOutSuppliersPageFilterKeysQueryParams();
  const { pageNumber } =
    useLoggedOutSuppliersPageZeroIndexedPageNumberQueryParams();

  const request = brandsSearchRequest({
    navigationPath: navigationPath,
    filterKeys: filterKeys,
    oneIndexedPageNumber: pageNumber + 1,
  });

  const requestKey = getQueryKey(request);

  return { request, requestKey };
};
